import { lazy, Suspense } from "react";
import { useLocale } from "use-intl";

import { SwipeableDrawer } from "@/components/Drawer/SwipeableDrawer";
import { AnimatedLoader } from "@/components/Loaders/AnimatedLoader";

const ArabicTerms = lazy(() => import("./ArabicTerms"));
const EnglishTerms = lazy(() => import("./EnglishTerms"));

const MoreDetailsDrawer = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const locale = useLocale();

  return (
    <SwipeableDrawer
      onClose={onClose}
      open={open}
      hasFullHeight
      heightOffset={100}
    >
      {open ? (
        <div className="prose-sm">
          <Suspense fallback={<AnimatedLoader icon="users" />}>
            {locale === "ar" ? <ArabicTerms /> : <EnglishTerms />}
          </Suspense>
        </div>
      ) : null}
    </SwipeableDrawer>
  );
};

export default MoreDetailsDrawer;
